import {
	Component, Input, Output, OnInit, OnChanges, SimpleChange, SimpleChanges, OnDestroy,
	ViewChild, EventEmitter, ChangeDetectorRef
} from '@angular/core';
import { MessageService } from 'base';
import { MonitorService } from 'monitor';
import { IdentityService } from 'identity';
import { MonitorEditorComponentBase } from '../MonitorEditorComponentBase';
import { ConfigSettingsComponent } from '../configsettings/configsettings.component';
import { MonitorScheduleComponent } from '../monitorschedule/monitorschedule.component';
import { MonitorEventsComponent } from '../monitorevents/monitorevents.component';
import { NavigationService } from 'netview';
import { Schedule } from 'DiscoveryEngine.TS/Utils';
import { ConfigDevicesComponent } from '../configdevices/configdevices.component';
import { ConfigTftpSettingsComponent } from '../configtftpsettings/configtftpsettings.component';


export class ConfigMonitorComponentState {
	public settingsChange: EventEmitter<boolean>;
	public copyChanges: EventEmitter<boolean>;

	constructor() {
		this.settingsChange = new EventEmitter<boolean>();
		this.copyChanges = new EventEmitter<boolean>()
	}
}


@Component({
	selector: 'config-monitor',
	templateUrl: './configmonitor.component.html',
	styleUrls: ['./configmonitor.component.scss']
})
export class ConfigMonitorComponent extends MonitorEditorComponentBase {

    @ViewChild(ConfigSettingsComponent, { static: true })
	public configSetsComponent: ConfigSettingsComponent;

	@ViewChild(ConfigDevicesComponent, { static: true })
	public configDevicesComponent: ConfigDevicesComponent;

    @ViewChild(MonitorScheduleComponent, { static: true })
	public monSchedComponent: MonitorScheduleComponent;

    @ViewChild(MonitorEventsComponent, { static: true })
	public monEventsComponent: MonitorEventsComponent;

//	@ViewChild(ConfigTftpSettingsComponent, { static: true })
//	public configTftpSetsComponent: MonitorEventsComponent;

	public monEditorState: ConfigMonitorComponentState;
	public activeTabIndex: number;

	constructor(monitorService: MonitorService,
		messageService: MessageService,
		identityService: IdentityService,
		navService: NavigationService,
		changeDetector: ChangeDetectorRef) {

		super(monitorService, messageService, identityService, navService, changeDetector);

		this.initMonEditorState();
		this.initActiveTabIndex();
	}

	private initMonEditorState(): void {
		this.monEditorState = new ConfigMonitorComponentState();
	}

	private initActiveTabIndex(): void {
		this.activeTabIndex = 0;
	}


	public ngOnInit(): void {
		super.ngOnInit();

		this.children = [
			this.configSetsComponent,
			this.configDevicesComponent,
			this.monSchedComponent,
			this.monEventsComponent,
//			this.configTftpSetsComponent,
		];
	}

	public ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);

		if (changes["visible"] && this.visible) {
			this.initMonEditorState();
			this.initActiveTabIndex();
		}
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	public get schedule(): Schedule {
		if (this.monSchedComponent)
			return this.monSchedComponent.value;
		else
			return new Schedule();
	}

	protected doSaveActions(): void {
		this.configDevicesComponent.syncConfigEntries();
	}

}
